/**
 * Query key used to fetch the bulk adjustment uploads
 */
export const GET_BULK_ADJUSTMENT_UPLOADS_QUERY_KEY = 'GET_BULK_ADJUSTMENT_UPLOADS_QUERY_KEY';
